import { isoLookups } from "./isoLookups";

export function formatProfileRow(row) {
  const extractNamePercent = (country) => {
    if (!country) return ["", ""];
    const [name, percentage] = country.split("(");
    return [name.trim(), percentage ? +percentage.replace("%)", "") : ""];
  };

  const iso3Lookup = (country) => (isoLookups[country] ? isoLookups[country]["iso3"] : "");
  const iso2Lookup = (country) => (isoLookups[country] ? isoLookups[country]["iso2"] : "");

  return {
    ...row,
    trading_partner_1_name_only: extractNamePercent(row["trading_partner_1_name"])[0],
    trading_partner_2_name_only: extractNamePercent(row["trading_partner_2_name"])[0],
    trading_partner_3_name_only: extractNamePercent(row["trading_partner_3_name"])[0],
    trading_partner_1_percentage: extractNamePercent(row["trading_partner_1_name"])[1],
    trading_partner_2_percentage: extractNamePercent(row["trading_partner_2_name"])[1],
    trading_partner_3_percentage: extractNamePercent(row["trading_partner_3_name"])[1],
    trading_partner_1_iso3: iso3Lookup(extractNamePercent(row["trading_partner_1_name"])[0]),
    trading_partner_2_iso3: iso3Lookup(extractNamePercent(row["trading_partner_2_name"])[0]),
    trading_partner_3_iso3: iso3Lookup(extractNamePercent(row["trading_partner_3_name"])[0]),
    trading_partner_1_iso2: iso2Lookup(extractNamePercent(row["trading_partner_1_name"])[0]),
    trading_partner_2_iso2: iso2Lookup(extractNamePercent(row["trading_partner_2_name"])[0]),
    trading_partner_3_iso2: iso2Lookup(extractNamePercent(row["trading_partner_3_name"])[0]),
    vaccines: row["vaccines"] ? row["vaccines"] : 0,
    vaccines_pop: row["vaccines_pop"] ? row["vaccines_pop"] : 0,
    vaccines_inflicted: row["vaccines_inflicted"] ? row["vaccines_inflicted"] : 0,
    year_sotj: row["year_sotj"] ? row["year_sotj"] : 2023,
    year_fsi: row["year_fsi"] ? row["year_fsi"] : 2022,
    year_cthi: row["year_cthi"] ? row["year_cthi"] : 2021,
  };
}
